import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { NativeWebViewProvider } from './nativeWebView';

const APP_QUERY_PARAM = 'app';
const APP_STORAGE_KEY = 'jz_active_app';
const LEGACY_APP_KEY = 'jz9454';
const MODERN_APP_KEY = 'jz9458';
const MOBILE_MEDIA_QUERY = '(max-width: 768px)';

const isJz9458Mode = () => {
  const queryApp = new URLSearchParams(window.location.search).get(APP_QUERY_PARAM);
  const isMobileViewport = window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  const storedApp = window.localStorage.getItem(APP_STORAGE_KEY);

  if (isMobileViewport) {
    return true;
  }

  if (queryApp === MODERN_APP_KEY) {
    return true;
  }

  if (queryApp === LEGACY_APP_KEY) {
    return false;
  }

  return storedApp === MODERN_APP_KEY;
};

const container = document.getElementById('root');
const root = createRoot(container);

const appTree = (
  <NativeWebViewProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </NativeWebViewProvider>
);

if (isJz9458Mode()) {
  root.render(appTree);
} else {
  root.render(
    <NativeWebViewProvider>
      <MantineProvider withGlobalStyles withNormalizeCSS theme={{
        colors: {
          brand: ['#F0BBDD', '#ED9BCF', '#EC7CC3', '#ED5DB8', '#F13EAF', '#F71FA7', '#044EB3', '#044EB3', '#C50E82', '#AD1374'],
        },
        primaryColor: 'brand',
      }}>
      <Provider store={store}>
        <BrowserRouter>
          <Notifications />
          <App />
        </BrowserRouter>
      </Provider>
      </MantineProvider>
    </NativeWebViewProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  });
}
